import Axios from 'axios'
const baseURL = 'https://api.doty.com.br/v1'

let axios = Axios.create({
  baseURL,
  withCredentials: true
})

export default axios
